import Login from "./AuthPages/Login";
import Game from "./MainPages/Game";
import GameHistory from "./MainPages/GameHistory";
import LeaderBoard from "./MainPages/Leaderboard";
import Roadmap from "./MainPages/RoadMap";
import TaskList from "./MainPages/TaskList";
import Wallet from "./MainPages/wallet";
import Friends from "./MainPages/Friends";
import Refferals from "./MainPages/Refferals";
import EarningsHistory from "./MainPages/EarningsHistory";
import Shop from "./MainPages/Shop";
import ShopHistory from "./MainPages/ShopHistory";
import PaymentVerification from "./MainPages/Payment";
import Signup from "./AuthPages/Signup";
import Signin from "./AuthPages/Signin";
import Verify from "./AuthPages/Verify";
import SuccessPage from "./MainPages/sucess";
import Jackpot from "./MainPages/Jackpot";
import JackpotHistory from "./MainPages/JackpotHistory";

export const routes = [
  { path: "/login", component: <Login /> },
  { path: "/sign-up", component: <Signup /> },
  { path: "/sign-in", component: <Signin /> },
  { path: "/verify-otp", component: <Verify /> },
  { path: "/success", component: <SuccessPage /> },
];

export const privateRoutes = [
  { path: "/game", component: <Game /> },
  { path: "/task", component: <TaskList /> },
  { path: "/wallet", component: <Wallet /> },
  { path: "/game-history", component: <GameHistory /> },
  { path: "/leaderboard", component: <LeaderBoard /> },
  { path: "/shop", component: <Shop /> },
  { path: "/shop-history", component: <ShopHistory /> },
  { path: "/roadmap", component: <Roadmap /> },
  { path: "/friends", component: <Friends /> },
  { path: "/refferals", component: <Refferals /> },
  { path: "/earnings", component: <EarningsHistory /> },
  { path: "/payments", component: <PaymentVerification /> },
  { path: "/jackpot", component: <Jackpot /> },
  { path: "/jackpot-history", component: <JackpotHistory /> },
];
